export default "__VITE_ASSET__ByuBjiQZ__"